import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { FlowChartDndTile, NodeModel } from 'ui/workflows/flowchart';
import { NodeTile, NodeTileProps } from 'ui/workflows/nodeTile';
import { NODE_TYPES } from 'modules/workflows/constants';
import { useJourneyAssistContext } from 'modules/workflows/context/JourneyAssistContext';

import { getBetaSupportedNodes } from '../../ducks';

export const Tile = ({ node, ...props }: NodeTileProps) => {
  const { type: nodeType, nodeData } = node?.data || {};

  const betaNodes = useSelector(getBetaSupportedNodes);

  const { isJourneyAssistActive } = useJourneyAssistContext();

  // Is the node currently enabled?
  const getIsEnabled = useCallback(() => {
    return nodeType === NODE_TYPES.NOTE || nodeType === NODE_TYPES.TILESET
      ? true
      : betaNodes?.includes(nodeData?.nodeClass);
  }, [nodeType, betaNodes]);

  const isDisabled = !getIsEnabled() || isJourneyAssistActive;

  return (
    <FlowChartDndTile model={node?.data as Partial<NodeModel>} isDisabled={isDisabled}>
      <NodeTile node={node} isDisabled={isDisabled} {...props} />
    </FlowChartDndTile>
  );
};

export default Tile;
